import Yox from 'yox'

import template from './template/ListItem.hbs'

import {
  FALSE,
  RAW_STRING,
  RAW_STYLE_TYPE,
} from '../constant'

import {
  findComponentUpward,
} from '../util'

export default Yox.define({

  template,

  name: 'bell-ListItem',

  propTypes: {
    className: {
      type: RAW_STRING,
    },
    style: {
      type: RAW_STYLE_TYPE,
    }
  },

  data(options) {
    const list = findComponentUpward(options.parent, 'bell-List')
    return {
      clickable: list
        ? list.get('clickable')
        : FALSE
    }
  }

})
